<template>
  <v-card
    class="pa-10 rounded-xl d-flex flex-column align-center"
    style="width: auto !important"
  >
    <div
      style="width: 920px; height: 288px; border: 1px solid; border-radius: 0"
      class="d-flex download-qr-code"
    >
      <div
        style="width: 288px; height: 100%; border-right: 1px solid"
        class="d-flex align-center justify-center"
      >
        <QRCode
          :value="asset.id.toString()"
          :size="250"
          level="M"
          render-as="svg"
        ></QRCode>
      </div>
      <div class="d-flex flex-column" style="flex-grow: 1">
        <div style="height: 50%; border-bottom: 1px solid" class="px-4">
          <div
            style="height: 50%; border-bottom: 1px solid"
            class="d-flex align-center justify-center"
          >
            <div
              v-for="n in 18"
              :key="n"
              class="number-cell"
              :class="{ 'ml-2': [4, 6, 10, 16].includes(n) }"
            >
              {{ asset_location_code[n - 1] }}
            </div>
            <div class="cct-label font-weight-bold ml-4 mr-4">CCT</div>
            <div v-for="n in 4" class="number-cell" :key="n">
              {{ asset?.asset_year[n - 1] }}
            </div>
          </div>
          <div style="height: 50%" class="d-flex align-center justify-center">
            <div
              class="number-cell"
              v-for="n in 16"
              :key="n"
              :class="{ 'ml-2': [2, 4, 6, 8, 11].includes(n) }"
            >
              {{ asset_concat_code_and_number?.[n - 1] }}
            </div>
          </div>
        </div>
        <div
          class="d-flex flex-column justify-center align-center"
          style="height: 50%"
        >
          <h2>PT. CIMANGGIS CIBITUNG TOLLWAYS</h2>
          <h3
            style="
              font-weight: 400;
              text-align: center;
              width: 100%;
              white-space: normal;
              overflow: hidden;
              padding: 0 15px;
              margin: 0;
            "
          >
            {{ asset.asset_name }}
          </h3>
        </div>
      </div>
    </div>
    <v-btn
      class="text-capitalize white--text mt-4"
      color="#004643"
      style="font-weight: 300"
      @click="download()"
      >Download
    </v-btn>
  </v-card>
</template>

<script>
import QRCode from "qrcode.vue";
import html2canvas from "html2canvas";

export default {
  components: {
    QRCode,
  },
  props: ["asset"],
  methods: {
    async download() {
      try {
        const element = document.querySelector(".download-qr-code");
        const padding = 10;
        const canvas = await html2canvas(element, {
          scale: 2,
          backgroundColor: "#ffffff",
          width: element.offsetWidth + padding * 2,
          height: element.offsetHeight + padding * 2,
          x: -padding,
          y: -padding,
        });

        const link = document.createElement("a");
        link.download = `qr-code-${this.asset.asset_code || "asset"}.png`;
        link.href = canvas.toDataURL("image/png");
        link.click();
        link.remove();
      } catch (error) {
        console.error("Error downloading QR code:", error);
      }
    },
  },
  computed: {
    asset_location_code() {
      const code = (this.asset.location_code || "").replace(/\./g, "");
      return code.slice(0, 18).split("");
    },
    asset_concat_code_and_number() {
      return (
        this.asset.real_asset_code?.replace(/\./g, "") +
        (this.asset.asset_number?.replace(/\./g, "")
          ? `${this.asset.asset_number?.replace(/\./g, "")}`
          : "")
      );
    },
  },
};
</script>

<style scoped>
.number-cell {
  border: 1px solid #000;
  width: 24px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
